// =============================================================================
// DATA / RENTALS.JS — Event rental companies (Calgary)
// Simple format: { name, ig, url, link, phone?, email? }
// =============================================================================

export const rentalData = [
  {
    name: "Modern Rentals",
    ig: "@modernrentals.ca",
    igLink: "https://www.instagram.com/modernrentals.ca/",
    url: "modernrentals.ca",
    link: "https://modernrentals.ca",
    phone: "403-319-0028",
    email: "info@modernrentals.ca",
  },
  {
    name: "Rori Ranch Rentals",
    ig: "@roriranch",
    igLink: "https://www.instagram.com/roriranch/",
    url: "roriranchrentals.ca",
    link: "https://roriranchrentals.ca",
    phone: null,
    email: "info@roriranchrentals.ca",
  },
  {
    name: "Special Event Rentals",
    ig: "@specialeventrentals_calgary",
    igLink: "https://www.instagram.com/specialeventrentals_calgary/",
    url: "calgary.specialeventrentals.com",
    link: "https://calgary.specialeventrentals.com",
    phone: "403-235-2211",
    email: null,
  },
  {
    name: "Wedding Finesse",
    ig: "@wedding_finesse_decor_calgary",
    igLink: "https://www.instagram.com/wedding_finesse_decor_calgary/",
    url: "weddingfinesse.ca",
    link: "https://www.weddingfinesse.ca",
    phone: "(403) 700-3773",
    email: "weddingfinesse@yahoo.ca",
    note: "By appointment only — ask for Masha.",
  },
  {
    name: "Vibe Rentals",
    ig: "@vibe.event.rentals",
    igLink: "https://www.instagram.com/vibe.event.rentals/",
    url: "viberentals.ca",
    link: "https://viberentals.ca/wedding-tent-packages/",
    phone: "(587) 688-1363",
    email: "hello@viberentals.ca",
    note: "Specializes in wedding tent packages.",
  },
  {
    name: "Fusion Bollywood",
    ig: null,
    igLink: null,
    url: "fusionbollywood.com",
    link: "https://fusionbollywood.com",
    phone: "(403) 605-8703 / (403) 605-1904",
    email: "dreamwedding@fusionbollywood.com",
  },
  {
    name: "Rocky Mountain Rental Co.",
    ig: "@rockymountainrentalcompany",
    igLink: "https://www.instagram.com/rockymountainrentalcompany/",
    url: "rockymountainrental.ca",
    link: "https://rockymountainrental.ca",
    phone: "587-973-5377",
    email: "info@rockymountainrental.ca",
  },
];
